export default __webpack_public_path__ + "static/media/fortisLogo.dd1c0f03.png";